"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DiagnosticLevel = exports.DataCategories = void 0;
/**
 * Privacy properties, compatible with OTel (only the subset we may use, and without an explicit dependency on OTelJS):
 * https://office.visualstudio.com/OE/_git/OTEL-OTelJS?path=%2Foteljs%2Fsrc%2FEventFlagsProperties.ts
 */
var DataCategories;
(function (DataCategories) {
    DataCategories[DataCategories["ProductServiceUsage"] = 2] = "ProductServiceUsage";
    DataCategories[DataCategories["ProductServicePerformance"] = 4] = "ProductServicePerformance";
})(DataCategories = exports.DataCategories || (exports.DataCategories = {}));
var DiagnosticLevel;
(function (DiagnosticLevel) {
    DiagnosticLevel[DiagnosticLevel["BasicEvent"] = 10] = "BasicEvent";
    DiagnosticLevel[DiagnosticLevel["FullEvent"] = 100] = "FullEvent";
    DiagnosticLevel[DiagnosticLevel["RequiredServiceDataEvent"] = 110] = "RequiredServiceDataEvent";
})(DiagnosticLevel = exports.DiagnosticLevel || (exports.DiagnosticLevel = {}));
//# sourceMappingURL=iclientruntime.js.map